import React from 'react'
import {FormControlLabel, Radio, withStyles} from '@material-ui/core';
import PropTypes from 'prop-types';
import clsx from 'clsx';

const style = theme => ({
    root: {},
})

function RadioGroupElement(
    {
        classes,
        value,
        children,
        size,
        labelClassName,
        className,
        disabled,
        htmlId
    }) {
    return (
        <FormControlLabel
            className={clsx(
                classes.root,
                className,
            )}
            value={value}
            control={<Radio id={htmlId} size={size} color="primary"/>}
            label={children}
            classes={{
                label: labelClassName
            }}
            disabled={disabled}
        />
    )
}

RadioGroupElement.propTypes = {
    classes: PropTypes.any,
}

export default withStyles(style)(RadioGroupElement);